<template>
  <div
    class="relative w-full min-h-[3200px] sm:min-h-[3200px] md:min-h-[2400px] lg:min-h-[2200px] xl:min-h-[1800px] flex-col items-center text-white px-6 mt-[40px] bg-[#102C64] lg:bg-hero-bg bg-no-repeat lg:bg-contain 2xl:bg-cover bg-top pt-[80px] lg:pt-[200px] pb-[80px] before:absolute before:top-0 before:left-0 before:w-full before:h-full before:bg-black before:opacity-40 before:z-0"
  >
    <!-- 18+ Age Verification Modal -->
    <WarnModal
      v-if="currentStep === 1"
      :isVisible="showAgeModal"
      title="Access Notice"
      message="By entering this site you acknowledge you cannot play the casinos linked here from Australia."
      confirmText="Yes"
      cancelText="No"
      @confirm="onAgeConfirmed"
      @cancel="onAgeRejected"
    />

    <!-- Gambling Responsibility Modal -->
    <WarnModal
      v-if="currentStep === 2"
      :isVisible="showAgeModal"
      title="Age Verification"
      message="I also verify that I am 18 years of age."
      confirmText="Yes"
      cancelText="No"
      @confirm="onResponsibilitiesAccepted"
      @cancel="onResponsibilitiesRejected"
    />

    <!-- Scrollable Content Wrapper -->
    <div class="w-full h-full custom-scrollbar flex flex-col items-center justify-start">
      <div
        v-motion-pop-visible
        class="flex flex-col lg:flex-row h-full max-h-[900px] md:max-h-[1000px] lg:h-[650px] lg:max-h-[650px] xl:max-h-[650px] w-full bg-gradient-to-r from-[#1D1D1D] to-[#313B44] max-w-6xl gap-6 p-6 rounded-xl"
      >
        <!-- Welcome Section -->
        <div
          class="text-center flex flex-col justify-start items-center w-full lg:w-1/2 relative z-10 h-full lg:h-[450px] p-6 rounded-lg"
        >
          <div
            class="flex gap-x-2 bg-[#FFB200] bg-opacity-20 text-[#FFD166] px-4 py-2 rounded-full border-2 border-[#FFB200] text-sm font-bold"
          >
            <img src="../assets/trophy-icon.png" alt="Trophy Icon" class="w-6 h-6" />
            Watch, Play & Win!
          </div>
          <h1
            class="text-white text-[36px] lg:text-[30px] xl:text-[50px] leading-none font-black font-golos mt-10"
          >
            Welcome to
            <span class="text-gray-300"
              ><br />
              Bally Boy’s Page</span
            >
          </h1>
          <p class="text-gray-400 mt-6 text-sm xl:text-sm">
            For the best casino rewards no matter your bet size!
          </p>

          <!-- Buttons -->
          <div
            class="mt-10 flex flex-col xl:flex-row justify-center gap-y-4 lg:gap-y-6 gap-x-4"
          >
            <a
              href="https://discord.gg/uFdSnxqubp"
              class="flex justify-center items-center gap-x-2 bg-blue-500 w-[200px] sm:w-[300px] lg:w-[200px] text-white text-sm px-4 py-2 rounded-md font-montserrat font-bold"
            >
              <img src="../assets/trophy-icon.png" alt="Discord" class="w-5 h-5" /> Join
              Discord Now
            </a>
            <router-link
              :to="{ path: '/leaderboards' }"
              class="flex justify-center w-[200px] sm:w-[300px] lg:w-[200px] items-center gap-x-2 bg-gray-700 text-white text-sm px-4 py-2 rounded-md font-montserrat font-bold"
            >
              <img src="../assets/chart.svg" alt="Leaderboard" class="w-5 h-5" />
              View Leaderboard
            </router-link>
          </div>

          <!-- Social Icons -->
          <div
            class="flex justify-center items-center gap-x-4 lg:gap-x-6 xl:gap-x-8 mt-12 lg:mt-20 xl:mt-12"
          >
            <a href="https://www.youtube.com/@BallyBoyGambles" target="_blank">
              <img src="../assets/socials-youtube.svg" alt="YouTube" class="w-8 h-8" />
            </a>
            <a href="https://www.kick.com/ballyslots" target="_blank">
              <img src="../assets/socials-kick.svg" alt="Kick" class="w-6 h-6" />
            </a>
            <a href="https://www.instagram.com/ballyboyofficial/#" target="_blank">
              <img
                src="../assets/socials-instagram.svg"
                alt="Instagram"
                class="w-9 h-9"
              />
            </a>
            <a href="https://x.com/Bally_BoyonKick" target="_blank">
              <img src="../assets/socials-twitter.svg" alt="Twitter" class="w-8 h-8" />
            </a>
            <a href="https://discord.gg/uFdSnxqubp" target="_blank">
              <img src="../assets/socials-discord.svg" alt="Discord" class="w-8 h-8" />
            </a>
          </div>
        </div>

        <!-- Stream Section -->
        <div
          class="relative flex justify-center items-center w-full h-full max-w-full lg:max-w-[560px] bg-opacity-80 backdrop-blur-md rounded-lg overflow-hidden"
        >
          <iframe
            src="https://player.kick.com/ballyslots"
            width="100%"
            height="345"
            frameborder="0"
            allowfullscreen
            class="rounded-lg"
          ></iframe>

          <!--        
            <template v-if="isLive">
            <iframe
              :src="twitchStreamHost"
              width="100%"
              height="345"
              md:height="345"
              frameborder="0"
              allowfullscreen
              class="rounded-lg"
            ></iframe>
          </template>

 
          <template v-else>
            <div
              class="relative w-full h-full flex flex-col justify-center items-start bg-stream-bg bg-cover bg-center p-4 md:p-6 rounded-lg"
            >
        
              <div
                class="absolute top-0 sm:top-[40px] md:top-[130px] lg:top-[200px] xl:top-[130px] 2xl:top-[130px] left-0 w-full h-full sm:h-[150px] md:h-[200px] bg-black opacity-50"
              ></div>

              <span
                class="relative z-10 bg-white text-black text-xs font-bold px-2 py-1 rounded-md"
              >
                Offline
              </span>

              <h3 class="relative z-10 text-white text-base md:text-lg font-bold mt-2">
                Meet BallyBoy
              </h3>
              <p
                class="relative z-10 text-gray-300 text-xs md:text-sm mt-1 leading-tight"
              >
                <a
                  href="https://www.twitch.tv/ballyboyslots/about"
                  class="text-[#9147FF] hover:underline"
                >
                  https://www.twitch.tv/ballyboyslots/about
                </a>
                <br />
                Climb the Leaderboard and Earn Big Rewards!
              </p>
            </div>
          </template> -->

          <!-- Inner Shadow at Bottom -->
        </div>
      </div>

      <!-- Promotions Section -->
      <div class="flex flex-col w-full max-w-7xl mx-auto mt-[100px] px-4">
        <h2 v-motion-pop-visible class="text-white text-2xl font-bold mb-6 font-golos">
          BallyBoy Promotions
        </h2>

        <!-- Grid Layout -->
        <div class="grid grid-cols-1 md:grid-cols-2 xl:flex flex-wrap justify-center items-center gap-6 mt-10 ">
          <div
            v-motion-pop-visible
            v-for="(promo, index) in promotions"
            :key="index"
            class="bg-gradient-to-r w-full xl:max-w-[360px] xl:max-h-[400px] from-[#1D1D1D] to-[#313B44] rounded-xl p-6 shadow-md border border-[#1F2A37] flex flex-col h-full"
          >
            <!-- Top Section (Logo + Amount) -->
            <div>
              <div class="flex items-center gap-3 mb-4">
                <img :src="promo.logo" alt="Promo Logo" class="w-[170px] h-auto" />
              </div>

              <p class="text-[#A3B3C2] text-sm font-montserrat">Leaderboard</p>
              <p
                class="text-yellow-400 font-extrabold text-2xl lg:text-lg xl:text-2xl mt-1 font-orbitron"
              >
                {{ promo.animatedAmount }}
              </p>

              <!-- Sign Up Button -->
              <button
                @click="openPromo(promo.url)"
                class="w-full bg-blue-500 text-white font-semibold py-3 rounded-md mt-4 text-sm xl:text-lg flex items-center justify-center gap-2 hover:bg-blue-600 hover:scale-105 transition-transform duration-300"
              >
                <img src="@/assets/gift-yellow.png" alt="Gift" class="w-5 h-5" />
                Sign Up
              </button>

              <!-- Benefits List -->
              <ul class="text-[#A3B3C2] mt-4 text-sm space-y-2">
                <li
                  v-for="(benefit, i) in promo.benefits"
                  :key="i"
                  class="flex items-center gap-2"
                >
                  <img src="@/assets/gift-white.png" alt="Check" class="w-4 h-4" />
                  {{ benefit }}
                </li>
              </ul>
            </div>

            <!-- Divider & Sign-Up Code (ALWAYS AT BOTTOM) -->
            <div @click="openPromo(promo.url)" class="mt-auto hover:cursor-pointer">
              <hr class="border-t border-gray-700 mt-6 w-full" />
              <p class="text-[#A3B3C2] text-sm mt-3">Sign Up and Use Code</p>
              <p class="text-white font-extrabold text-lg mt-2">{{ promo.code }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WarnModal from "@/components/WarnModal.vue";
import { defineComponent } from "vue";
import { mapActions } from "vuex";

export default defineComponent({
  components: {
    WarnModal,
  },
  computed: {
    showAgeModal() {
      const expiryTime = this.$store.state.expiryTime;
      const now = Date.now();

      if (!this.$store.state.ageConfirmed || !this.$store.state.responsibilityConfirmed) {
        return true;
      }

      if (expiryTime && now >= expiryTime) {
        this.$store.dispatch("checkExpiry"); // Reset confirmations if expired
        return true;
      }

      return false;
    },
  },
  data() {
    return {
      isLive: false,
      twitchStreamHost: process.env.VUE_APP_TWITCH_STREAM_HOST,
      streamer: "ballyboyslots",
      currentStep: 1,
      promotions: [
        {
          title: "Metaspins",
          logo: require("@/assets/promo-metaspins.png"),
          currencySymbol: "$",
          currencyPosition: "prefix",
          amount: 0,
          animatedAmount: "0.00",
          envKey: "VUE_APP_METASPINS_LEADERBOARD_CURRENT_PRIZES",
          benefits: ["100% First Deposit Bonus (40x Wager)"],
          code: "BALLYBOY",
          url: "https://metamedialinks.com/e36249d00",
        },
        {
          title: "Empiredrop",
          logo: require("@/assets/promo-empiredrop.png"),
          currencySymbol: "€",
          currencyPosition: "prefix",
          amount: 0,
          animatedAmount: "0.00",
          envKey: "VUE_APP_EMPIREDROP_LEADERBOARD_CURRENT_PRIZES",
          benefits: ["5 Free Boxes", "+ 10% Deposit Offer"],
          code: "BALLYBOY",
          url: "https://empiredrop.com/?r=Ballyboy",
        },
        {
          title: "DAILYSPINS",
          logo: require("@/assets/promo-dailyspins.png"),
          currencySymbol: "$",
          currencyPosition: "prefix",
          amount: 0,
          animatedAmount: "0.00",
          envKey: "VUE_APP_DAILYSPINS_LEADERBOARD_CURRENT_PRIZES",
          benefits: [
            "Receive 200 free spins",
            "Receive 100% up to $100 on your first deposit",
          ],
          code: "BALLYBOY",
          url: "https://dailyspins.com/?ref=BALLYBOY",
        },

        {
          title: "RAIN.GG",
          logo: require("@/assets/promo-raingg.png"),
          currencySymbol: "$",
          currencyPosition: "prefix",
          amount: 0,
          animatedAmount: "0.00",
          envKey: "VUE_APP_RAINGG_LEADERBOARD_CURRENT_PRIZES",
          benefits: ["5 Free Boxes", "+ 10% Deposit Offer"],
          code: "BALLYBOY",
          url: "https://rain.gg/r/Ballyboy",
        },
         {
          title: "CHICKEN.GG",
          logo: require("@/assets/promo-chickengg.png"),
          currencySymbol: "$",
          currencyPosition: "prefix",
          amount: 0,
          animatedAmount: "0.00",
          envKey: "VUE_APP_CHICKENGG_LEADERBOARD_CURRENT_PRIZES",
          benefits: ["Receive up to 200 free spins", "Receive 100% up to $,1000 on your first deposit"],
          code: "BALLYBOY",
          url: "https://chicken.gg/r/Ballyboy",
        },
      ],
    };
  },

  methods: {
    ...mapActions(["toggleApology", "acceptAge", "acceptResponsibilities"]),
    onAgeConfirmed() {
      this.currentStep = 2;
      this.acceptAge();
    },
    onAgeRejected() {
      this.showAgeModal = false;
      this.toggleApology(true);
      this.$router.push("/apology");
    },
    onResponsibilitiesAccepted() {
      this.showAgeModal = false;
      this.currentStep = 3;
      this.acceptResponsibilities();
    },
    onResponsibilitiesRejected() {
      this.toggleApology(true);
      this.$router.push("/apology");
    },
    async checkStreamStatus() {
      try {
        const response = await fetch(
          `https://api.twitch.tv/helix/streams?user_login=${this.streamer}`,
          {
            headers: {
              "Client-ID": "YOUR_TWITCH_CLIENT_ID",
              Authorization: "Bearer YOUR_TWITCH_ACCESS_TOKEN",
            },
          }
        );
        const data = await response.json();

        this.isLive = data.data.length > 0;

        if (this.isLive) {
          this.streamUrl = `https://player.twitch.tv/?channel=${this.streamer}&parent=www.ballyboy.store&localhost`;
        }
      } catch (error) {
        console.error("Error checking Twitch stream status:", error);
      }
    },
    getTotalPrizeAmount(prizeEnvVar) {
      const prizeString = process.env[prizeEnvVar];
      const prizeArray = prizeString ? JSON.parse(prizeString) : [];

      // Sum all the prizes
      const totalAmount = prizeArray.reduce((sum, prize) => sum + prize, 0);

      // Return the total amount, formatted with commas
      return totalAmount;
    },
    formatCurrency(value, symbol = "$", position = "prefix") {
      const formatted = Number(value).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

      return position === "prefix" ? symbol + formatted : formatted + symbol;
    },
    animateNumber(variable, targetValue, symbol = "$", position = "prefix") {
      let startValue = parseFloat(this[variable].replace(/,/g, "")) || 0;
      if (startValue === targetValue) return;

      const step = Math.max(1, Math.abs(targetValue - startValue) / 20);
      const isDecreasing = startValue > targetValue;

      const interval = setInterval(() => {
        if (isDecreasing) {
          startValue -= step;
          if (startValue <= targetValue) {
            startValue = targetValue;
            clearInterval(interval);
          }
        } else {
          startValue += step;
          if (startValue >= targetValue) {
            startValue = targetValue;
            clearInterval(interval);
          }
        }

        const formatted = Number(startValue).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });

        this[variable] = position === "prefix" ? symbol + formatted : formatted + symbol;
      }, 50);
    },

    animatePromoValue(index, targetValue, symbol, position) {
      // Create a proxy ref to allow same animateNumber logic

      let startValue =
        parseFloat(this.promotions[index].animatedAmount.replace(/[^0-9.]/g, "")) || 0;
      if (startValue === targetValue) return;

      const step = Math.max(1, Math.abs(targetValue - startValue) / 20);
      const isDecreasing = startValue > targetValue;

      const interval = setInterval(() => {
        if (isDecreasing) {
          startValue -= step;
          if (startValue <= targetValue) {
            startValue = targetValue;
            clearInterval(interval);
          }
        } else {
          startValue += step;
          if (startValue >= targetValue) {
            startValue = targetValue;
            clearInterval(interval);
          }
        }

        const formatted = Number(startValue).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });

        this.promotions[index].animatedAmount =
          position === "prefix" ? symbol + formatted : formatted + symbol;
      }, 50);
    },

    openPromo(url) {
      window.open(url, "_blank");
    },
  },

  mounted() {
    this.checkStreamStatus();

    this.promotions.forEach((promo, index) => {
      const total = this.getTotalPrizeAmount(promo.envKey);
      promo.amount = total;

      // Animate using your leaderboard-style logic
      this.animatePromoValue(index, total, promo.currencySymbol, promo.currencyPosition);
    });
  },
});
</script>

<style scoped>
/* Custom scrollbar */
.custom-scrollbar::-webkit-scrollbar {
  width: 5px; /* Thin scrollbar */
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: #1d1d1d; /* Dark track to match the sidebar */
  border-radius: 10px;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background: #313b44; /* Slightly lighter scrollbar for visibility */
  border-radius: 10px;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #1294f0; /* Highlight color on hover */
}
</style>
